import gsap from "gsap";
const coreLi = document.querySelectorAll(".pfa_item");
const img = document.querySelectorAll(".pfa_item img");
window.addEventListener("load", function () {
  gsap.set(coreLi[0], {
    width: 596,
  });
  gsap.set(coreLi[1], {
    width: 293,
  });
  gsap.set(coreLi[2], {
    width: 293,
  });
  gsap.set(img[1], {
    x: -100,
  });
  gsap.set(img[2], {
    x: -300,
  });
});

const tl = gsap.timeline({duration: 0.3});
//监听鼠标移入移出事件
// const coreLi = document.querySelectorAll('.pfa_item');
coreLi.forEach((item, index) => {
  item.addEventListener("mouseenter", function () {
    gsap.to([coreLi[0], coreLi[1], coreLi[2]], {
      width: 293,
    });
    gsap.to(coreLi[index], {
      width: 596,
    });
    if (index == 0) {
      gsap.to(img[1], {
        x: -100,
      });
      gsap.to(img[2], {
        x: -300,
      });
    }
    if (index == 1) {
      gsap.to(img[2], {
        x: -300,
      });
      gsap.to(img[1], {
        x: 0,
      });
    }
    if (index == 2) {
      gsap.to(img[1], {
        x: -100,
      });
      gsap.to(img[2], {
        x: 0,
      });
    }
  });
  item.addEventListener("mouseleave", function (event) {
    let index = event.target.getAttribute("data-id");

    coreLi.forEach((li, i) => {
      if (li === this) {
        gsap.to(li, {width: 596, duration: 0});
      } else {
        gsap.to(li, {width: 293, duration: 0});
      }
    });

    // if(index == '1'){
    //     gsap.to(img[1],{
    //         x:-100,
    //         // duration:0.1,
    //      })
    // }
    // if(index == '2'){
    //     gsap.to(img[2],{
    //         x:-300,
    //         // duration:0.1,
    //      })
    // }
  });
});
